import { c as _c } from "react/compiler-runtime";
import { useErrorContext } from "@context-providers/error-boundary/error-handling-context";
import { companyBrandingSettingsSelector } from "@store/sdb-company/sdb-company-selector";
import { fetchCompanyBrandingSettings, updateCompanyBrandingSettings } from "@store/sdb-company/sdb-company-slice-thunk";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { WorkspaceEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";

/** Default empty branding settings if not available for users  */
const DefaultBrandingSettings = {
  logo: {
    url: "",
    target: "",
    // eslint-disable-next-line @typescript-eslint/naming-convention -- defined in the backend
    showHoloBuilderLogo: true
  }
};
/** Returns branding settings of the company */
export function useBrandingSettings() {
  const $ = _c(13);
  const dispatch = useAppDispatch();
  const {
    handleErrorWithToast
  } = useErrorContext();
  const {
    trackEvent
  } = useTrackEvent();
  const brandingSettings = useAppSelector(companyBrandingSettingsSelector);
  const hasBrandingSettings = Boolean(brandingSettings);
  const companyBrandingSettings = brandingSettings?.logo ? brandingSettings : DefaultBrandingSettings;
  let t0;
  if ($[0] !== dispatch) {
    t0 = async function fetchBrandingSettings() {
      await dispatch(fetchCompanyBrandingSettings());
    };
    $[0] = dispatch;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const fetchBrandingSettings = t0;
  let t1;
  if ($[2] !== brandingSettings || $[3] !== companyBrandingSettings || $[4] !== dispatch || $[5] !== handleErrorWithToast || $[6] !== trackEvent) {
    t1 = async function onChangeBrandingSettings(value, attribute) {
      if (!brandingSettings) {
        return value;
      }
      ;
      try {
        trackEvent({
          name: WorkspaceEvents.updateSettings,
          props: {
            attribute
          }
        });
        await dispatch(updateCompanyBrandingSettings({
          payload: {
            ...companyBrandingSettings,
            logo: {
              ...companyBrandingSettings.logo,
              [attribute]: value
            }
          }
        }));
      } catch (t2) {
        const error = t2;
        handleErrorWithToast({
          id: `changeCompanyBrandingSettings-${Date.now().toString()}`,
          title: "Sorry! Unable to change the value",
          error
        });
        return value;
      }
      return value;
    };
    $[2] = brandingSettings;
    $[3] = companyBrandingSettings;
    $[4] = dispatch;
    $[5] = handleErrorWithToast;
    $[6] = trackEvent;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const onChangeBrandingSettings = t1;
  let t2;
  if ($[8] !== companyBrandingSettings || $[9] !== fetchBrandingSettings || $[10] !== hasBrandingSettings || $[11] !== onChangeBrandingSettings) {
    t2 = {
      fetchBrandingSettings,
      brandingSettings: companyBrandingSettings,
      hasBrandingSettings,
      onChangeBrandingSettings
    };
    $[8] = companyBrandingSettings;
    $[9] = fetchBrandingSettings;
    $[10] = hasBrandingSettings;
    $[11] = onChangeBrandingSettings;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  return t2;
}